<div class="viewport-1">
  <background></background>
  <img class="overlay-fil-logo" src="/assets/images/wordflight_vrt_color_pos_rgb.svg" />
  <div class="demo-select-form">
    <form name="demoSelectForm" class="form demo-form-wrapper">
      @if (errorMessage != null) {
        <div class="alert alert-danger demo-alert font-17">{{errorMessage}}</div>
      }
      <div class="demo-header-wrapper">
        @if (username) {
          <div [class]="{'font-20': (username.length || 0) >= 16, 'font-26': (username.length || 0) < 16}" class="demo-header">Welcome {{username}}</div>
        }
      </div>
      <div id="demo-subscription-options" class="demo-radio-group font-20" style="text-align:center;">
        @for (option of subscriptionOptions; track option; let i = $index) {
          <label>
            <input
              type="radio"
              name="subscription"
              (change)="onSubscriptionChange($event)"
                    [disabled]="disableButtons || (systemDemoDisabled && subscriptionOptions[i].key === systemSubscriptionKey) ||
                                (diagnosticDemoDisabled && subscriptionOptions[i].key === diagnosticSubscriptionKey)"
              [value]="subscriptionOptions[i].key"
              [checked]="subscription === subscriptionOptions[i].key"
              />
            {{ subscriptionOptions[i].value }}
          </label>
        }
      </div>
      <div [class.demo-form-group]="true">
        <div>
          <label class="demo-field-text font-27" for="curriculum">Curriculum</label>
          <select id="curriculum" name="curriculum" class="demo-dropdown font-20" [(ngModel)]="curriculum" [disabled]="disableButtons">
            @for (curriculumOption of curriculumOptions; track curriculumOption) {
              <option [ngValue]="curriculumOption.key">{{curriculumOption.value}}</option>
            }
          </select>
        </div>
        <div>
          <label class="demo-field-text font-27" for="placement">Placement</label>
          <select id="placement" name="placement" class="demo-dropdown font-20" [(ngModel)]="placement" [disabled]="disableButtons || subscription !== systemSubscriptionKey">
            @for (placement of placementArr; track placement) {
              <option [ngValue]="placement">{{placement.displayText}}</option>
            }
          </select>
        </div>
        <div>
          <label class="demo-field-text font-27" for="wordlist">Initial Wordlist level</label>
          <select id="wordlist" name="wordlist" class="demo-dropdown font-20" [(ngModel)]="wordlist" [disabled]="subscription !== systemSubscriptionKey || disableButtons">
            @for (wordListOption of wordListOptions; track wordListOption) {
              <option [ngValue]="wordListOption.key">{{wordListOption.value}}</option>
            }
          </select>
        </div>
        <div class="demo-submit-btn">
          <button type="submit"(click)="submit()" [disabled]="disableButtons"></button>
        </div>
      </div>
      @if (showLoading) {
        <div class="spinning-loader"></div>
      }
    </form>
  </div>
  <version-footer></version-footer>
  <instructions></instructions>
</div>
